const oneSignalInitializerSnippet = (appID: string) => `
        window.OneSignalDeferred = window.OneSignalDeferred || [];
          OneSignalDeferred.push(function(OneSignal) {
            OneSignal.init({
              appId: "${appID}",
            });
          });
`;

const oneSignalSWLoaderSnippet = `
const maxRetries = 3;
let retryCount = 0;

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    registerServiceWorker();
  });
}

function registerServiceWorker() {
  navigator.serviceWorker
    .register('/hubfs/web/sw/OneSignalSDKWorker.js')
    .catch(() => {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(registerServiceWorker, 1500);
      }
    });
}
`;

export { oneSignalInitializerSnippet, oneSignalSWLoaderSnippet };
